import { init } from './init';
import * as ecodeLib from './sdk';

import libVersion from './libVersion';
init();

export { ready, loadAsyncReady } from './init';
export const version = libVersion;
export const { asyncImport, jsonp, relative } = ecodeLib;
